import React from "react";
import { IconBaseProps } from "react-icons";

export const MailSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill={fill}
    fillRule="evenodd"
    display="block"
  >
    <path d="M13 12.435l8.881-7.13a1.965 1.965 0 0 0-.833-.187H4.952c-.31 0-.571.07-.833.188L13 12.436z" />
    <path d="M13.595 14.388A.921.921 0 0 1 13 14.6a.921.921 0 0 1-.595-.212L3.048 6.882V18.53c0 1.035.857 1.882 1.904 1.882h16.096c1.047 0 1.904-.847 1.904-1.883V7v-.118l-9.357 7.506z" />
  </svg>
);
